export const COMPLETE_STEP = "basic-details/COMPLETE_STEP";
export const COUNTRIES_LOADED = "basic-details/COUNTRIES_LOADED";
export const COUNTRY_CHANGED = "basic-details/COUNTRY_CHANGED";
export const FIELD_BLURRED = "basic-details/FIELD_BLURRED";
export const FIELD_CHANGED = "basic-details/FIELD_CHANGED";
export const LIBRARIES_LOADED = "basic-details/LIBRARIES_LOADED";
export const LOCAL_LIBRARY_CHANGED = "basic-details/LOCAL_LIBRARY_CHANGED";
export const LOCAL_STORAGE_LOADED = "basic-details/LOCAL_STORAGE_LOADED";
export const LOCAL_STORAGE_SYNCED = "basic-details/LOCAL_STORAGE_SYNCED";
export const REGION_CHANGED = "basic-details/REGION_CHANGED";
export const SET_SHOW_LOCAL_LIBRARY_OTHER = "basic-details/SET_SHOW_LOCAL_LIBRARY_OTHER";
export const SUBDIVISIONS_LOADED = "basic-details/SUBDIVISIONS_LOADED";
export const ROLES_LOADED = "basic-details/ROLES_LOADED";

export const ROLE_CHANGED = "basic-details/ROLE_CHANGED";
export const CONTRIBUTOR_FIELD_BLURRED = "basic-details/CONTRIBUTOR_FIELD_BLURRED";
export const CONTRIBUTOR_FIELD_CHANGED = "basic-details/CONTRIBUTOR_FIELD_CHANGED";
export const CONTRIBUTOR_ROLE_CHANGED = "basic-details/CONTRIBUTOR_ROLE_CHANGED";

export const countriesLoaded = countries => ({
  type: COUNTRIES_LOADED,
  countries,
});

export const librariesLoaded = libraries => ({
  type: LIBRARIES_LOADED,
  libraries,
});

export const subdivisionsLoaded = subdivisions => ({
  type: SUBDIVISIONS_LOADED,
  subdivisions,
});

export const loadSudivisions = countryCode => ({
  type: LOCAL_STORAGE_LOADED,
  countryCode,
});

export const localStorageLoaded = data => ({
  type: LOCAL_STORAGE_LOADED,
  data,
});

export const localStorageSynced = () => ({ type: LOCAL_STORAGE_SYNCED });
